/* Plant hero gallery — thumbnail → main-image swap + click-to-zoom lightbox.
   Event-delegated so it survives Shopify section re-renders in the theme
   editor and needs no per-element init. Guarded so re-injection of the
   section script doesn't stack listeners or duplicate the overlay. */
(function () {
  if (window.__plantGalleryBound) return;
  window.__plantGalleryBound = true;

  function swapMain(thumbBtn) {
    var root = thumbBtn.closest('[data-plant-gallery]');
    if (!root) return;
    var mainImg = root.querySelector('.plant-gallery__main-img');
    var full = thumbBtn.getAttribute('data-full');
    if (mainImg && full) {
      // Drop the density srcset and let the single chosen src govern, so the
      // browser doesn't over-fetch the largest width-descriptor candidate.
      mainImg.removeAttribute('srcset');
      mainImg.src = full;
    }
    var thumbs = root.querySelectorAll('.plant-gallery__thumb');
    for (var i = 0; i < thumbs.length; i++) thumbs[i].classList.remove('is-active');
    var li = thumbBtn.closest('.plant-gallery__thumb');
    if (li) li.classList.add('is-active');
  }

  var overlay = null;
  var lastTrigger = null;

  function getOverlay() {
    if (overlay) return overlay;
    overlay = document.querySelector('.plant-lightbox');
    if (overlay) return overlay;
    overlay = document.createElement('div');
    overlay.className = 'plant-lightbox';
    overlay.setAttribute('hidden', '');
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.setAttribute('aria-label', 'Powiększone zdjęcie');
    overlay.innerHTML =
      '<button type="button" class="plant-lightbox__close" aria-label="Zamknij">&times;</button>' +
      '<img class="plant-lightbox__img" alt="">';
    document.body.appendChild(overlay);
    overlay.addEventListener('click', function (e) {
      if (e.target === overlay || e.target.closest('.plant-lightbox__close')) closeLightbox();
    });
    return overlay;
  }

  function openLightbox(mainBtn) {
    var img = mainBtn.querySelector('.plant-gallery__main-img');
    if (!img) return;
    var el = getOverlay();
    el.querySelector('.plant-lightbox__img').src = img.currentSrc || img.src;
    lastTrigger = mainBtn;
    el.removeAttribute('hidden');
    document.documentElement.classList.add('plant-lightbox-open');
    var close = el.querySelector('.plant-lightbox__close');
    if (close) close.focus();
  }

  function closeLightbox() {
    if (!overlay || overlay.hasAttribute('hidden')) return;
    overlay.setAttribute('hidden', '');
    document.documentElement.classList.remove('plant-lightbox-open');
    if (lastTrigger && typeof lastTrigger.focus === 'function') lastTrigger.focus();
    lastTrigger = null;
  }

  document.addEventListener('click', function (e) {
    var thumb = e.target.closest('[data-gallery-thumb]');
    if (thumb) { swapMain(thumb); return; }
    var main = e.target.closest('[data-gallery-main]');
    if (main) openLightbox(main);
  });

  document.addEventListener('keydown', function (e) {
    if (!overlay || overlay.hasAttribute('hidden')) return;
    if (e.key === 'Escape') { closeLightbox(); return; }
    // Only the close button is focusable inside → keep focus trapped on it.
    if (e.key === 'Tab') {
      var close = overlay.querySelector('.plant-lightbox__close');
      if (close) { e.preventDefault(); close.focus(); }
    }
  });
})();
